import { CREATE_FLOOR_URL, DELETE_FLOOR_URL, FLOOR_LIST_DROPDOWN, FLOOR_SINGLE_DETAIL, LIST_FLOOR_URL } from "../api";
import axiosInstance from "../axiosInstance";

export const createFloor = (props) => onResponse => {
    try {
        axiosInstance.post(CREATE_FLOOR_URL, props)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err?.response?.data);
            });

    } catch (error) {

    }

};

export const listFloor = (props) => onResponse => {
    try {
        let BASE_URL = LIST_FLOOR_URL + '?'
        if (props?.page) {
            BASE_URL += 'page=' + props.page + '&'
        }
        if (props?.limit) {
            BASE_URL += 'limit=' + props.limit + '&'
        }
        if (props?.search) {
            BASE_URL += 'search=' + props.search + '&'
        }
        if (props?.order) {
            BASE_URL += 'order=' + props.order + '&'
        }
        if (props?.sort) {
            BASE_URL += 'sort_by=' + props.sort + '&'
        }

        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err?.response?.data);
            });

    } catch (error) {

    }

};

export const getSingleFloorDetail = (props) => onResponse => {
    try {
        let BASE_URL = FLOOR_SINGLE_DETAIL + '?'
        if (props?.page) {
            BASE_URL += 'page=' + props.page + '&'
        }
        if (props?.id) {
            BASE_URL += 'id=' + props.id + '&'
        }

        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err?.response?.data);
            });

    } catch (error) {

    }

};

export const deletefloor = (props) => onResponse => {
    try {


        axiosInstance.delete(DELETE_FLOOR_URL, { data: { id: props?.id } })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err?.response?.data);
            });

    } catch (error) {

    }

};

export const listFloorDropdown = (props) => onResponse => {
    try {
        let BASE_URL = FLOOR_LIST_DROPDOWN + '?'
        if (props.page) {
            BASE_URL += 'page=' + props.page + '&'
        }
        if (props.limit) {
            BASE_URL += 'limit=' + props.limit + '&'
        }
        if (props.search) {
            BASE_URL += 'search=' + props.search + '&'
        }
        if (props.building_id) {
            BASE_URL += 'building_id=' + props.building_id + '&'
        }
        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err?.response?.data);
            });



    } catch (error) {

    }
}